import { createSlice } from '@reduxjs/toolkit'

export const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    value: {
      test:0,
      themeLoader: "CircleLoader",
      muiTheme: {
        typography: {
          h6: {
            fontSize: "1.2em",
            // fontWeight:"bold",
          },

          fontFamily: [
          'Audiowide',
      'Poppins',
      'Rajdhani',
      'Orbitron',
      'Exo 2',
      'Audiowide',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol',
          ].join(','),
        },
        palette: {
          mode: "light",
          primary: {
            main: '#007BFF',
            // light:"#00FFFF",
            // light: will be calculated from palette.primary.main,
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
          },
          secondary: {
            main: '#66B2FF',
            // dark: will be calculated from palette.secondary.main,
            // contrastText: '#47008F',
          },
          info: {
            main: '#2ca02c',
          },
          success: {
            main: '#1E90FF',
          },
          electricblue: {
            main: '#1E90FF',
          },
          aqua: {
            main: '#00FFFF',
           
          },
          orange : {
            main: '#FFA500',
          },
          purple : {
            main: '#9B30FF',
          },
          green : {
            main: '#32CD32',
          },
          darkgray : {
            main: '#121212',
          },
          lightgray : {
            main: '#F5F5F5',
          },
          midgray : {
            main: '#2E2E2E',
          },
          error : {
            main: '#FF4500',
          },
          danger : {
            main: '#FFA500',
          },

        },
        components: {
          MuiButton: {
            defaultProps: {
              size: 'small',
              color:'secondary'
            },
          },
          MuiAppBar: {
            defaultProps: {
        
              color:'primary'
            },
          },
          
          MuiFilledInput: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiFormControl: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiFormHelperText: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiIconButton: {
            defaultProps: {
              size: 'small',
            },
          },
          MuiInputBase: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiInputLabel: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiListItem: {
            defaultProps: {
              dense: true,
            },
          },
          MuiOutlinedInput: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiFab: {
            defaultProps: {
              size: 'small',
            },
          },
          MuiTable: {
            defaultProps: {
              size: 'small',
            },
          },
          MuiTextField: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiToolbar: {
            defaultProps: {
              variant: 'dense',
            },
          },
        },
      },
    },
  },
  reducers: {
    change: (state) => {

      state.value = {
        ...state.value

      }
    },
    test:(state, action) => {

      state.value = {
        ...state.value.test = action.payload

      }
    },


  },
})


export const { change , test} = themeSlice.actions

export default themeSlice.reducer